/* eslint-disable react/jsx-closing-tag-location */
import React, { Component, Fragment } from 'react';
import ReactPlayer from 'react-player';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Accordion } from 'react-accessible-accordion';

import { mp, getCampaign } from '../../constants/utils';
import Steps from './Steps';
import {
  CertifiedModalContent,
  StyledVideoWrapper,
  StyledThumb,
  StyledResultsDescription,
  CompareImage,
} from './resultsStyles';
import Title from './Title';
import Text from './Text';
import Modal from './Modal';
import FAQuestion from '../landing/FAQuestion';
import CTAButton from './CTAButton';
import { breakpoints } from '../../constants/styles';
import ProductOptions from './ProductOptions';

const VideoResultados = 'https://s3.us-east-2.amazonaws.com/finauta/thumbnails/metasResultados.jpg';

const MyCertifiedModal = css`
  max-height: none;
  margin: 0;
  border-radius: 0px;
  width: 100vw;
  min-height: 100vh;

  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  ${breakpoints.tablet} {
    height: fit-content;
    width: 70vw;
    margin-top: 5vh;
    margin-bottom: 5vh;
  }
`;

const StyledVideoDiv = styled.div`
  align-self: center;
  width: 100%;
  ${breakpoints.tablet} {
    width: 80%;
  }
`;

const StyledConvModalTitle = css`
  margin-bottom: 10px;
`;

class ConvertingModal extends Component {
  state = {
    displayThumbnail: true,
  };

  render() {
    const { stepsAction, stepsValue, customMessage, toolName, show, closeCallback } = this.props;
    const { displayThumbnail } = this.state;
    return (
      <Modal
        show={show}
        onCloseModal={() => {
          closeCallback();
        }}
        styles={MyCertifiedModal}
      >
        {() => (
          <CertifiedModalContent>
            <Title level={3} align="center" styles={StyledConvModalTitle}>
              Empieza hoy mismo
            </Title>
            <StyledVideoDiv>
              <StyledVideoWrapper>
                <StyledThumb
                  src={VideoResultados}
                  onClick={() => {
                    this.setState({ displayThumbnail: !displayThumbnail });
                  }}
                  displayThumb={displayThumbnail}
                />
                <ReactPlayer
                  width="97%"
                  height="100%"
                  className="react-player-styled"
                  style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    display: displayThumbnail ? 'none' : 'block',
                  }}
                  playing={!displayThumbnail}
                  config={{
                    youtube: {
                      playerVars: {
                        start: 7,
                        modestbranding: 1,
                        showinfo: 0,
                      },
                    },
                  }}
                  onStart={() => {
                    mp(getCampaign(window.location.href));
                    mp('Ahorro');
                    mp('Se va');
                    mp('Reproducir video');
                  }}
                  onPause={() => {
                    mp(getCampaign(window.location.href));
                    mp('Ahorro');
                    mp('Se va');
                    mp('Pausar video');
                  }}
                  onEnded={() => {
                    mp(getCampaign(window.location.href));
                    mp('Ahorro');
                    mp('Se va');
                    mp('Video terminó');
                  }}
                  controls
                  cc_load_policy={1}
                  url="https://www.youtube.com/watch?v=mD_20j2Cgvg?cc_load_policy=1"
                />
              </StyledVideoWrapper>
            </StyledVideoDiv>
            <Steps steps={stepsAction} center />
            <Title level={3} align="center">
              ¿Por qué con Finauta?
            </Title>
            <Steps steps={stepsValue} customBullet />
            <Accordion
              accordion={false}
              style={{
                width: '100%',
                marginBottom: '10px',
                marginTop: '20px',
                maxWidth: '750px',
              }}
            >
              <FAQuestion
                question={{
                  question: 'Conoce tus opciones',
                  answer: <ProductOptions productType="savings" />,
                  // <StyledResultsDescription>
                  //   <CompareImage src="https://s3.us-east-2.amazonaws.com/finauta/iterations/compare1.jpg" />
                  // </StyledResultsDescription>,
                }}
                borderBottom
              />
            </Accordion>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignContent: 'center',
                width: '100%',
              }}
            >
              <CTAButton
                customMessage={customMessage}
                linkStyles={css`
                  align-self: center;
                  margin-top: 10px;
                `}
                internalLink="/registro"
                buttonText="Registro"
                event={`Savings | ${toolName}-Modal | Estoy interesado`}
              />
            </div>
            <Accordion
              accordion={false}
              style={{
                width: '100%',
                marginBottom: '10px',
                marginTop: '20px',
                maxWidth: '750px',
              }}
            >
              <FAQuestion
                question={{
                  question: '¿Cómo que es gratis?',
                  answer: (
                    <StyledResultsDescription>
                      <Text type="body1">
                        La institución financiera que tú elijas para llevar a cabo tu plan nos paga
                        una comisión por haberte ayudado a encontrarla.
                      </Text>
                    </StyledResultsDescription>
                  ),
                }}
                borderBottom
              />
            </Accordion>
          </CertifiedModalContent>
        )}
      </Modal>
    );
  }
}

ConvertingModal.propTypes = {
  stepsAction: PropTypes.array,
  stepsValue: PropTypes.array,
  closeCallback: PropTypes.func,
  show: PropTypes.bool,
  customMessage: PropTypes.string,
  toolName: PropTypes.string,
};

ConvertingModal.defaultProps = {
  closeCallback: () => {},
  stepsAction: [
    {
      content: (
        <Fragment>
          Registrate
          <Link
            style={{ color: 'blue', marginLeft: '0.3em' }}
            to={{
              pathname: '/registro',
              state: {
                customMessage: 'templateMessage',
              },
            }}
          >
            aquí
          </Link>
        </Fragment>
      ),
    },
    { content: 'Conoce tus opciones' },
    { content: 'Elige tu opción preferida' },
  ],
  stepsValue: [
    {
      content: 'Somos 100% imparciales',
      subtitle: 'Ya que no somos parte de ninguna institución financiera',
      icon: 'independentBullet',
    },
    {
      content: 'Listos cuando tú lo estés',
      subtitle:
        'Si tú trabajas hasta tarde, nosotros también. Estamos disponibles cuando tú lo estés.',
      icon: 'timeBullet',
    },
    {
      content: 'Nuestros expertos están certificados',
      subtitle: 'Sus certificaciones aseguran que las recomendaciónes que provean sean de calidad.',
      icon: 'certificationBullet',
    },
  ],
  show: false,
  customMessage: 'templateMessage',
  toolName: 'undefined',
};

export default ConvertingModal;
